import instance from "../config";

// Acceso con huella / reconocimiento facial (WebAuthn).
// Las opciones vienen con un tokenDesafio que se devuelve al verificar.

// Dispositivos activados por el usuario en sesión -> [{ id, credencialId, dispositivo, ultimoUso, createdAt }]
export const getMisDispositivos = async () => {
  const { data } = await instance.get("/biometria");
  return data;
};

// -> { opciones, tokenDesafio }
export const opcionesActivarBiometria = async () => {
  const { data } = await instance.post("/biometria/registro/opciones");
  return data;
};

// -> { msg, credencialId }
export const activarBiometria = async (tokenDesafio, respuesta, dispositivo) => {
  const { data } = await instance.post("/biometria/registro/verificar", { tokenDesafio, respuesta, dispositivo });
  return data;
};

// -> { msg }
export const desactivarBiometria = async (id) => {
  const { data } = await instance.delete(`/biometria?id=${id}`);
  return data;
};

// -> { opciones, tokenDesafio }
export const opcionesLoginBiometria = async () => {
  const { data } = await instance.post("/biometria/login/opciones");
  return data;
};

// -> mismos datos de sesión que el login: { token, expiresIn, rol, username }
// acceso: "superadmin" desde el login privado del superadmin
export const loginBiometria = async (tokenDesafio, respuesta, acceso) => {
  const { data } = await instance.post("/biometria/login/verificar", { tokenDesafio, respuesta, acceso });
  return data;
};
